import { EXERCISE_DURATION_UNIT } from "@/lib/constants";
import styles from "@/styles/Video.module.scss";

export default function RightViewTerm({ right }) {
  if (!right) return null;
  const [label, text] = rightViewTerm(right);
  if (!label) return null;
  return (
    <span className={styles.rightViewLimit}>
      <span className={styles.label}>{label}</span>
      <span>{text}</span>
    </span>
  );
}

export function rightViewTerm(right) {
  if (right?.exercise_term) {
    return [
      "視聴可能期間",
      `視聴開始後${right.exercise_term}${
        EXERCISE_DURATION_UNIT[right?.exercise_term_unit]?.label
      }`,
    ];
  } else if (right?.view_limit_date) {
    return ["視聴期間", `決済日から${right.view_limit_date}まで`];
  }
  return [];
}
